module.exports = [ '$scope', '$http', function($scope, $http) {
  $scope.submitted = false;

  $scope.submit = function () {
    if ($scope.form.$valid) {
      $http.post('/api/contact', $scope.contact).then(
        function success(data) {
          $scope.submitted = true;
          (ga||angular.noop)('send', 'pageview', '/contact-success');
        },
        function error(data) {
          (ga||angular.noop)('send', 'pageview', '/contact-failed');
        });
    }
  };
}];


//////////////////
// WEBPACK FOOTER
// ./assets/app/formContact.controller.js
// module id = 5
// module chunks = 0